import { commission_initial_values } from "features/AffiliateMarketing/modules/AffiliateCommissionForm/constants/AffiliateCommissionForm.constant";
import { country_codes } from "features/Common/modules/Phone/constants/CountryCodes.constants";
import { getUserCountryCode } from "utils/AuthUtil";

export const getAddAffiliateFormInitialValues = () => ({
  country_code: getUserCountryCode() ?? country_codes.IN.dial_code,
  phone_number: "",
  ...commission_initial_values,
});
